export const permissions = [
  {
    id: 1,
    code: 'tiles-charts',
    name: 'Tiles & Charts',
  },
  {
    id: 2,
    code: 'organization-create',
    name: 'Organization-Create',
  },
  {
    id: 3,
    code: 'organization-edit',
    name: 'Organization-Edit',
  },
  {
    id: 4,
    code: 'organization-delete',
    name: 'Organization-Delete',
  },
  {
    id: 5,
    code: 'organization-view',
    name: 'Organization-View',
  },
  {
    id: 6,
    code: 'organization-list',
    name: 'Organization-List',
  },
  {
    id: 7,
    code: 'facility-create',
    name: 'Facility-Create',
  },
  {
    id: 8,
    code: 'facility-edit',
    name: 'Facility-Edit',
  },
  {
    id: 9,
    code: 'facility-delete',
    name: 'Facility-Delete',
  },
  {
    id: 10,
    code: 'facility-view',
    name: 'Facility-View',
  },
  {
    id: 11,
    code: 'facility-list',
    name: 'Facility-List',
  },
  {
    id: 39,
    code: 'facility-category-list',
    name: 'FacilityCategory-List',
  },
  {
    id: 40,
    code: 'facility-wordbank-list',
    name: 'FacilityWordBank-List',
  },
  {
    id: 41,
    code: 'facility-questionbank-list',
    name: 'FacilityQuestionBank-List',
  },
  {
    id: 24,
    code: 'category-create',
    name: 'Category-Create',
  },
  {
    id: 25,
    code: 'category-edit',
    name: 'Category-Edit',
  },
  {
    id: 26,
    code: 'category-delete',
    name: 'Category-Delete',
  },
  {
    id: 28,
    code: 'category-list',
    name: 'Category-List',
  },
  {
    id: 29,
    code: 'keyword-create',
    name: 'Keyword-Create',
  },
  {
    id: 30,
    code: 'keyword-edit',
    name: 'Keyword-Edit',
  },
  {
    id: 31,
    code: 'keyword-delete',
    name: 'Keyword-Delete',
  },

  {
    id: 33,
    code: 'keyword-list',
    name: 'Keyword-List',
  },
  {
    id: 34,
    code: 'question-create',
    name: 'Question-Create',
  },
  {
    id: 35,
    code: 'question-edit',
    name: 'Question-Edit',
  },
  {
    id: 36,
    code: 'question-delete',
    name: 'Question-Delete',
  },
  {
    id: 38,
    code: 'question-list',
    name: 'Question-List',
  },

  {
    id: 18,
    code: 'user-create',
    name: 'User-Create',
  },
  {
    id: 19,
    code: 'user-edit',
    name: 'User-Edit',
  },
  {
    id: 20,
    code: 'user-delete',
    name: 'User-Delete',
  },
  {
    id: 21,
    code: 'user-view',
    name: 'User-View',
  },
  {
    id: 22,
    code: 'user-list',
    name: 'User-List',
  },

  {
    id: 12,
    code: 'referral-create',
    name: 'Referral-Create',
  },
  {
    id: 13,
    code: 'referral-edit',
    name: 'Referral-Edit',
  },
  {
    id: 14,
    code: 'referral-delete',
    name: 'Referral-Delete',
  },
  {
    id: 15,
    code: 'referral-view',
    name: 'Referral-View',
  },
  {
    id: 17,
    code: 'referral-list',
    name: 'Referral List',
  },
  {
    id: 42,
    code: 'referral-hold',
    name: 'Referral Hold',
  },
  {
    id: 43,
    code: 'referral-hold-list',
    name: 'Referral Hold List',
  },
  {
    id: 44,
    code: 'referral-lost',
    name: 'Referral Lost',
  },
  {
    id: 45,
    code: 'referral-lost-list',
    name: 'Referral Lost List',
  },
  {
    id: 46,
    code: 'referral-draft',
    name: 'Referral Draft',
  },
  {
    id: 47,
    code: 'referral-processing',
    name: 'Referral Processing',
  },

  {
    id: 48,
    code: 'referral-pending-clerical-review',
    name: 'Pending Clerical Review',
  },
  {
    id: 49,
    code: 'referral-clerical-review',
    name: 'Clerical Review',
  },
  {
    id: 50,
    code: 'referral-clerical-submitted',
    name: 'Clerical Submitted',
  },
  {
    id: 51,
    code: 'referral-clerical-denial-pending',
    name: 'Clerical Denial Pending',
  },
  {
    id: 52,
    code: 'referral-clinical-review',
    name: 'Clinical Review',
  },
  {
    id: 53,
    code: 'referral-clinical-submitted',
    name: 'Clinical Submitted',
  },
  {
    id: 54,
    code: 'referral-clinical-denial-pending',
    name: 'Clinical Denial Pending',
  },
  {
    id: 55,
    code: 'referral-community-review',
    name: 'Community Review',
  },
  {
    id: 56,
    code: 'referral-community-accepted',
    name: 'Community Accepted',
  },
  {
    id: 57,
    code: 'referral-community-denial-review',
    name: 'Community Denial Review',
  },
  {
    id: 58,
    code: 'referral-clerical-denial-approved',
    name: 'Clerical Denial Approved',
  },
  {
    id: 59,
    code: 'referral-clerical-denial-overturned',
    name: 'Clerical Denial Overturned',
  },
  {
    id: 60,
    code: 'referral-clinical-denial-approved',
    name: 'Clinical Denial Approved',
  },
  {
    id: 61,
    code: 'referral-clinical-denial-overturned',
    name: 'Clinical Denial Overturned',
  },
  {
    id: 62,
    code: 'referral-community-denial-approved',
    name: 'Community Denial Approved',
  },
  {
    id: 63,
    code: 'referral-community-denial-overturned',
    name: 'Community Denial Overturned',
  },
  {
    id: 64,
    code: 'referral-pending-patient-admission',
    name: 'Pending Patient Admission',
  },
  {
    id: 65,
    code: 'referral-pending-patient-request',
    name: 'Pending Patient Request',
  },
  {
    id: 66,
    code: 'referral-pending-patient-admitted',
    name: 'Pending Patient Admitted',
  },
  {
    id: 67,
    code: 'referral-pending-patient-rejected',
    name: 'Pending Patient Rejected',
  },
  {
    id: 68,
    code: 'drug-price',
    name: 'Drug Price',
  },
  {
    id: 69,
    code: 'notification-pending-clerical-review',
    name: 'Pending Clerical Review',
  },
  {
    id: 70,
    code: 'notification-clerical-submitted',
    name: 'Clerical Submitted',
  },
  {
    id: 71,
    code: 'notification-clerical-denial-pending',
    name: 'Clerical Denial Pending',
  },
  {
    id: 72,
    code: 'notification-clerical-denial-approved',
    name: 'Clerical Denial Approved',
  },
  {
    id: 73,
    code: 'notification-clerical-denial-overturned',
    name: 'Clerical Denial Overturned',
  },
  {
    id: 74,
    code: 'notification-clinical-submitted',
    name: 'Clinical Submitted',
  },
  {
    id: 75,
    code: 'notification-clinical-denial-pending',
    name: 'Clinical Denial Pending',
  },
  {
    id: 76,
    code: 'notification-community-accepted',
    name: 'Community Accepted',
  },

  {
    id: 77,
    code: 'notification-community-denial-review',
    name: 'Community Denial Review',
  },

  {
    id: 78,
    code: 'notification-lost',
    name: 'Lost',
  },
  {
    id: 79,
    code: 'taskList-accept',
    name: 'TaskListAccept',
  },
  {
    id: 80,
    code: 'taskList-deny',
    name: 'TaskListDeny',
  },
  {
    id: 83,
    code: 'referral-unlock',
    name: 'Referral Unlock',
  },
  {
    id: 86,
    code: 'regenerate-pdf',
    name: 'RegeneratePDF',
  },
  {
    id: 87,
    code: 'notif-pdf-upload-failure',
    name: 'PDF upload failure',
  },
  {
    id: 88,
    code: 'hra-list',
    name: 'HRA-List',
  },
  {
    id: 89,
    code: 'hra-create',
    name: 'HRA-Create',
  },
  {
    id: 90,
    code: 'hra-update',
    name: 'HRA-Update',
  },
  {
    id: 91,
    code: 'hra-delete',
    name: 'HRA-Delete',
  },
  {
    id: 92,
    code: 'revert-to-clinical-review',
    name: 'Revert to Clinical Review',
  },
  {
    id: 93,
    code: 'revert-to-community-review',
    name: 'Revert to Community Review',
  },
  {
    id: 94,
    code: 'revert-to-intake-review',
    name: 'Revert to Intake Review',
  },
  {
    id: 95,
    code: 'skip-intake-review',
    name: 'Skip Intake Review',
  },
  {
    id: 96,
    code: 'skip-clinical-review',
    name: 'Skip Clinical Review',
  },
  {
    id: 97,
    code: 'skip-community-review',
    name: 'Skip Community Review',
  },
  {
    id: 98,
    code: 'unlock_user_accounts',
    name: 'Unlock User Accounts',
  },
  {
    id: 23,
    code: 'view_and_manage_roles',
    name: 'View and Manage Roles page',
  },
  {
    id: 99,
    code: 'role_creation',
    name: 'Role Creation',
  },
  {
    id: 100,
    code: 'role_update',
    name: 'Role Update',
  },
  {
    id: 101,
    code: 'role_delete',
    name: 'Role Delete',
  },
  {
    id: 102,
    code: 'role_clone',
    name: 'Role Clone',
  },
  {
    id: 103,
    code: 'intake_review_actions',
    name: 'Intake Review',
  },
  {
    id: 104,
    code: 'clinical_review_actions',
    name: 'Clinical Review',
  },
  {
    id: 105,
    code: 'community_review_actions',
    name: 'Community Review',
  },
  {
    id: 106,
    code: 'denial_review_actions',
    name: 'Denial Review',
  },
  {
    id: 107,
    code: 'accepted_review_actions',
    name: 'Accepted Review',
  },
  {
    id: 108,
    code: 'view_sister_communities',
    name: 'View Sister Communities',
  },
  {
    id: 109,
    code: 'referral_manual_admit',
    name: 'Referral Manual Admit',
  },
  {
    id: 110,
    code: 'source-hospital-listing',
    name: 'Source Hospital Listing',
  },
  {
    id: 111,
    code: 'source-hospital-creation',
    name: 'Source Hospital Creation',
  },
  {
    id: 112,
    code: 'source-hospital-update',
    name: 'Source Hospital Update',
  },
  {
    id: 113,
    code: 'source-hospital-delete',
    name: 'Source Hospital Delete',
  },
  {
    id: 114,
    code: 'lost-rationale-listing',
    name: 'Lost Rationale Listing',
  },
  {
    id: 115,
    code: 'lost-rationale-creation',
    name: 'Lost Rationale Creation',
  },
  {
    id: 116,
    code: 'lost-rationale-update',
    name: 'Lost Rationale Update',
  },
  {
    id: 117,
    code: 'lost-rationale-delete',
    name: 'Lost Rationale Delete',
  },
  {
    id: 118,
    code: 'hold-rationale-listing',
    name: 'Hold Rationale Listing',
  },
  {
    id: 119,
    code: 'hold-rationale-creation',
    name: 'Hold Rationale Creation',
  },
  {
    id: 120,
    code: 'hold-rationale-update',
    name: 'Hold Rationale Update',
  },
  {
    id: 121,
    code: 'hold-rationale-delete',
    name: 'Hold Rationale Delete',
  },
  {
    id: 122,
    code: 'denial-management-rationale-listing',
    name: 'Denial Management Rationale Listing',
  },
  {
    id: 123,
    code: 'denial-management-rationale-creation',
    name: 'Denial Management Rationale Creation',
  },
  {
    id: 124,
    code: 'denial-management-rationale-update',
    name: 'Denial Management Rationale Update',
  },
  {
    id: 125,
    code: 'denial-management-rationale-delete',
    name: 'Denial Management Rationale Delete',
  },
  {
    id: 126,
    code: 'enable-mfa',
    name: 'Enable MFA',
  },
  {
    id: 127,
    code: 'reset-mfa',
    name: 'Reset MFA',
  },
  {
    id: 128,
    code: 'template-configuration',
    name: 'Template Configuration',
  },
  {
    id: 129,
    code: 'task-delete',
    name: 'Task Delete',
  },
  {
    id: 130,
    code: 'rules-creation',
    name: 'Rules Creation',
  },
  {
    id: 131,
    code: 'operations',
    name: 'Operations',
  },
  {
    id: 132,
    code: 'administration',
    name: 'Administration',
  },
  {
    id: 133,
    code: 'user-performance',
    name: 'User Performance',
  },
  {
    id: 134,
    code: 'community-capability-create',
    name: 'Community Capability Create',
  },
  {
    id: 135,
    code: 'community-capability-update',
    name: 'Community Capability Update',
  },
  {
    id: 136,
    code: 'community-capability-list',
    name: 'Community Capability List',
  },
  {
    id: 137,
    code: 'community-capability-delete',
    name: 'Community Capability Delete',
  },
  {
    id: 138,
    code: 'community-capability-bulk-upload',
    name: 'Community Capability Bulk Upload',
  },
  {
    id: 139,
    code: 'bed-board-management',
    name: 'Bed Board Management',
  },
  {
    id: 140,
    code: 'status-threshold-list',
    name: 'Status Threshold List',
  },
  {
    id: 142,
    code: 'status-threshold-update',
    name: 'Status Threshold Update',
  },
  {
    id: 144,
    code: 'lead-listing',
    name: 'Lead Listing',
  },
  {
    id: 145,
    code: 'lead-view',
    name: 'Lead View',
  },
  {
    id: 146,
    code: 'lead-creation',
    name: 'Lead Creation',
  },
  {
    id: 147,
    code: 'lead-update',
    name: 'Lead Update',
  },
  {
    id: 148,
    code: 'lead-delete',
    name: 'Lead Delete',
  },
  {
    id: 149,
    code: 'lead-convert',
    name: 'Lead Convert',
  },
  {
    id: 150,
    code: 'crm-listing',
    name: 'CRM Listing',
  },
  {
    id: 151,
    code: 'crm-creation',
    name: 'CRM Creation',
  },
  {
    id: 152,
    code: 'crm-update',
    name: 'CRM Update',
  },
  {
    id: 153,
    code: 'crm-delete',
    name: 'CRM Delete',
  },
  {
    id: 154,
    code: 'crm-view-activities',
    name: 'CRM View Activities',
  },
  {
    id: 155,
    code: 'crm-map-source-hospital',
    name: 'CRM Map Source Hospital',
  },
]
